import {
  DEAL_SALE_B2B_PROMO_URL_FALLBACK,
  DEAL_PROCESS_VIDEO_IFRAME_URL_FALLBACK,
} from '../../constants/linkFallbacks';
import { ILinksState } from '../../types/redux/links';

export const linksReducerDefaultState = {
  dealSaleB2bPromoUrl: DEAL_SALE_B2B_PROMO_URL_FALLBACK,
  dealProcessVideoIframeUrl: DEAL_PROCESS_VIDEO_IFRAME_URL_FALLBACK,
};

export function linksReducer(state: ILinksState = linksReducerDefaultState) {
  return state;
}
